import type { GetLocationResponse } from "@/openapi/generated/models";

/** Public page: show trimmed description when present. */
export function getLocationOptionalDescription(
  location: GetLocationResponse | null | undefined,
): string | null {
  if (!location) return null;
  const raw = location.description;
  const s = typeof raw === "string" ? raw.trim() : "";
  return s.length > 0 ? s : null;
}
